<template>
<div class="has-text-centered mtb-2">
  <p class="is-size-3">{{ environment.name }} is not setup.</p>
  <p class="mt-1">To get started run a scan from the terminal in the enviroment.</p>
  <p class="has-text-weight-bold has-text-danger mt-3">
    php artisan snitch:scan
  </p>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  
  computed: mapGetters('environment', ['environment'])

}
</script>